// Menú v2 (reacomodo: Inicio, Conversaciones, Ventas, Servicio, Agenda, Clientes,
// Agentes IA, Informes, Ajustes). En `false` vuelve el menú anterior tal cual
// —y las pantallas de casos vuelven a su selector de clase de siempre—: ese es
// el respaldo para regresarlo. Ver docs/vault-tickets/implementacion/Plan-Reacomodo-Menu.md.
export const MENU_V2 = true;
